<template>
  <!--    首页单屏-->
  <div class="banner">
    <video ref="video" id="videoBanner" :src="src" muted autoplay loop></video>
    <div class="title">城市微场景数据服务及整体解决方案提供商</div>
  </div>
</template>
<script>
import { originUrl } from "@/utils";
export default {
  data() {
    return {
      src: `${originUrl}fs-sm/video/banner.mp4`
    };
  },
  mounted() {
    this.$refs["video"].load();
  }
};
</script>
<style lang="less" scoped>
.banner {
  position: relative;
  font-size: 0;
  video {
    position: relative;
    width: 100%;
    object-fit: cover;
  }
  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 2.9rem;
    font-weight: bold;
    font-family: "Microsoft YaHei", "PINGFANG", "PingFang SC",
      "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei";
    color: #ffffff;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    letter-spacing: 7px;
  }
}
.cover {
  position: relative;
  width: 100%;
  height: 30rem;
  min-height: 30rem;
  overflow: hidden;
  // background: url("~@/assets/images/home/banner.png") no-repeat top;
  background-size: cover;
}
.cover-text {
  display: block;
  position: absolute;
  left: 24.5rem;
  top: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);

  .main {
    font-size: 2.1rem;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 2px;
  }
}
</style>
